<div class="auto-save-snack-bar">
  <span>{{data.superobject_type_id_value}}</span>
  <span translate="TRANS__AUTO_SAVE_SNACK_BAR__SAVED"></span>
  <span>{{updatedAt}}</span>
</div>
